import Vue from 'vue';

import AppButton from '@/directives/AppButtonDirective';
import AppBackButtonDirective from '@/directives/AppBackButtonDirective';

Vue.use('app-button', AppButton);
Vue.use('app-back-button-directive', AppBackButtonDirective);
